import { ApiClient } from '../../core/api/ApiClient';
import { AdherenceRepositoryImpl } from './implementations';
import { AdherenceService } from './services';

export * from './implementations';
export * from './interfaces';
export * from './services';

class AdherenceDomainContainer {
  constructor() {
    this._apiClient = null;
    this._adherenceRepository = null;
    this._adherenceService = null;
  }

  get apiClient() {
    if (!this._apiClient) {
      const baseURL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api/v1';
      this._apiClient = new ApiClient(baseURL);
    }
    return this._apiClient;
  }

  get adherenceRepository() {
    if (!this._adherenceRepository) {
      this._adherenceRepository = new AdherenceRepositoryImpl(this.apiClient);
    }
    return this._adherenceRepository;
  }

  get adherenceService() {
    if (!this._adherenceService) {
      this._adherenceService = new AdherenceService(this.adherenceRepository);
    }
    return this._adherenceService;
  }

  reset() {
    this._apiClient = null;
    this._adherenceRepository = null;
    this._adherenceService = null;
  }
}

const container = new AdherenceDomainContainer();

export const getAdherenceService = () => container.adherenceService;
export const resetAdherenceContainer = () => container.reset();
